import { Controller } from "@hotwired/stimulus";

export default class SearchDropdownController extends Controller {
  static targets = ["searchIcon", "closeIcon"];

  connect() {
    this.element.addEventListener("shown.bs.dropdown", this.showCloseIcon);
    this.element.addEventListener("hidden.bs.dropdown", this.showSearchIcon);
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.dropdown", this.showCloseIcon);
    this.element.removeEventListener("hidden.bs.dropdown", this.showSearchIcon);
  }

  showCloseIcon = () => {
    this.searchIconTarget.classList.add("d-none");
    this.closeIconTarget.classList.remove("d-none");
  };

  showSearchIcon = () => {
    this.closeIconTarget.classList.add("d-none");
    this.searchIconTarget.classList.remove("d-none");
  };
}
